export { default } from "./Person";



// WEBPACK FOOTER //
// ./src/components/client-search/Person/index.js